module.exports = __webpack_public_path__ + "media/images/printer/lan-806332f7a16146ce16254d07448a4a11.svg";